<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">3</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>{{model.Step3fTitle}}</h3>
                <p class="qualifier-tool-subheader">{{model.Step3fSubTitle}}</p>
            </div>
        </div>
        <div class="row d-flex justify-content-center qualifier-tool-footer">
            <a :href="model.Step3InnovageNewsUrl.replace('~', '..')" class="qualifier-tool-btn">{{model.Step3InnovageNewsTitle}}</a>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
			}
		},
		computed: mapState({
		}),
		components: {
		},
		mounted: function () {	
            this.clearSubmissionData();
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step3E'});    
            }
		},
		methods: {
            ...mapMutations('WebQualifierTool', { clearSubmissionData: 'clearSubmissionData' }),
        },
    }
</script>
